<template>
  <div
    :class="classes"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
import cellMixin from './cellMixin'

export default {
  mixins: [cellMixin]
}
</script>
